<template>
  <div class="summary" v-if="exportSummary">
    <b>Export pour Gcoll2 des ids du dossier de sélection "{{ name }}"</b>
    <div>
      Export de <b>{{ totalN }}</b> fiches Navigart3 (donc <b>{{ totalN }}</b> ids dans le fichier exporté), qui aura
      pour résultat d'import dans Gcoll2 <b>{{ totalNN }}</b> fiches (<b>{{ n1 }}</b> individuelles +
      <b>{{ n2 }}</b> liées d'ensembles dissociables + <b>{{ n8 }}</b> liées d'ensembles indissociables).
    </div>
    <div class="mb-2">Détail de l'export par types de fiche:</div>
    <ul>
      <li v-if="n1">
        <b>{{ n1 }}</b> fiches individuelles
      </li>
      <li v-if="n2">
        <b>{{ n2 }}</b> fiches d'éléments d'ensemble dissociable
        <span
          v-translate="{ n2: n2, n6: n6 }"
          :translate-n="n6"
          translate-plural="(pour info, ces %{n2} fiches appartiennent à %{n6} ensembles différents)"
        >
          (pour info, ces %{n2} fiches appartiennent à 1 ensemble)
        </span>
      </li>
      <li v-if="n7">
        <b>{{ n7 }}</b> ids de fiches d'ensemble indissociable*, représentant un total de <b>{{ n8 }}</b> fiches
        liées<br />
        *ou dissociable/N3=1 fiche (récape + liées) <br />
        (pour un ensemble indissociable, l'id de la fiche récape suffit pour retrouver toutes les liées dans l'import
        Gcoll2)
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CartImportSummary',
  computed: {
    ...mapGetters('carts', ['exportSummary']),
    name() {
      const { cart } = this.exportSummary;
      return cart;
    },
    type() {
      const { type } = this.exportSummary;
      const { separable = 0, nonseparable = 0, individual = 0 } = type;
      return { separable, nonseparable, individual };
    },
    n1() {
      return this.type.individual;
    },
    n2() {
      return this.type.separable;
    },
    n6() {
      return this.exportSummary.separable;
    },
    n7() {
      return this.exportSummary.nonseparable.headers.ids;
    },
    n8() {
      return this.exportSummary.nonseparable.headers.elements;
    },
    totalN() {
      return this.n1 + this.n2 + this.n7;
    },
    totalNN() {
      return this.n1 + this.n2 + this.n8;
    },
  },
};
</script>
